import { useState, useCallback, useEffect } from 'react';


export function useAccordionData(fetchFn, { refetchOnEveryOpen = true, defaultExpanded = false, eager = false, unmountOnExit = false } = {}) {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded || eager);
    const [isLoading, setIsLoading] = useState(false);
    const [hasFetched, setHasFetched] = useState(false);

    useEffect(() => {
        if (eager && fetchFn && !hasFetched) {
            setIsLoading(true);
            Promise.resolve(fetchFn())
                .then(() => setHasFetched(true))
                .finally(() => setIsLoading(false));
        }
    }, [eager, fetchFn, hasFetched]);

    const onAccordionChange = useCallback((_, expanded) => {
        setIsExpanded(expanded);
        if (expanded && fetchFn) {
            if (refetchOnEveryOpen || !hasFetched) {
                setIsLoading(true);
                Promise.resolve(fetchFn())
                    .then(() => setHasFetched(true))
                    .finally(() => setIsLoading(false));
            }
        }
    }, [fetchFn, refetchOnEveryOpen, hasFetched]);

    const invalidate = useCallback(() => {
        setHasFetched(false);
    }, []);

    const accordionProps = {
        expanded: isExpanded,
        onChange: onAccordionChange,
    };
    if (unmountOnExit) {
        accordionProps.TransitionProps = { unmountOnExit: true };
    }

    return {
        isExpanded,
        setIsExpanded,
        isLoading,
        hasFetched,
        onAccordionChange,
        invalidate,
        accordionProps,
    };
}
